import Enumerable from "linq";
import {
  IItem,
  instanceOfICalculatedValueValidatable,
  ICalculatedValueValidatable,
} from "../items";
import { IDocumentAlert } from "../IDocumentAlert";
import { CalculationAlert } from "../alerts";
import { AbstractItemValidator } from "./AbstractItemValidator";

export class CalculatedValueValidator extends AbstractItemValidator {
  protected validateItem(item: IItem, itemSetId: number): IDocumentAlert[] {
    return Enumerable.from([
      !this.isValid(item) ? new CalculationAlert(itemSetId, item as IItem & ICalculatedValueValidatable) : null,
    ])
    .toArray();
  }

  private isValid(item: IItem): boolean {
    return !instanceOfICalculatedValueValidatable(item)
      || !item.shouldCalculate
      || !item.isCalculatedValueEmpty;
  }
}
